import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { IntroColumn } from '../../../components/onboarding/IntroColumn';
import { SignInForm } from '../../../components/onboarding/vtex-only/SignInForm';
import { fadeInAndUp } from '../../../services/shared/animation.service';
import { capitalizeFirstLetter, setEcommerceURL } from '../../../services/shared/utils.service';
import { useAuthStore } from '../../../store';

import { customerName, customerRouteName } from '../../../data/InfoSource';
import { clearStorage } from '../../../services/storage';

export const SignIn = () => {
  let history = useHistory();
  const location = useLocation();
  const ecommerce = setEcommerceURL(location);
  const addAuth = useAuthStore((state) => state.addAuthData);

  useEffect(() => {
    clearStorage()
    if (ecommerce) {
      addAuth({
        user: {
          ecommerce: ecommerce,
        },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecommerce])

  useEffect(() => {
    document.title = `${customerName} - ${capitalizeFirstLetter(ecommerce)}`
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid" id="welcome">
      <div className="row">
        <IntroColumn ecommerce={ecommerce} />
        <div className="col col-xxl-8 form-col">
          <motion.div className="form-wrapper" variants={fadeInAndUp} initial="hidden" animate="visible">
            <h2 className="small-title fw-bold">
              Iniciar Sesión
            </h2>
            <SignInForm ecommerce={ecommerce} />
            <p className="medium-text">
              ¿Es tu primera vez en esta aplicación?, <button onClick={() => history.push(`/${customerRouteName}/vtex/vconfig`)} target="_blank" rel="noreferrer" className="btn-link fw-bold p-0">comienza aquí</button>.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  )
}
